import { GhostPost } from 'src/common/interfaces';
export const getPdfUrls = (post: GhostPost) => {
  const pdfLink = post.html.replace(/(<([^>]+)>)/gi, '');
  return pdfLink;
};